<!--
  a11y: role=button card — tabindex="0" + Enter/Space handlers (not native <a>, so inner buttons stay valid).
-->
<div role="button" tabindex="0"
  class="line-search-card-link flex flex-col min-h-40 cursor-pointer items-start border-2 border-solid border-gray-500 rounded-xl w-full min-w-0 outline-none"
  [attr.aria-label]="cardAriaLabel"
  (click)="onLineLinkClick($event)"
  (keydown.enter)="onLineLinkKeyActivate($event)"
  (keydown.space)="onLineLinkKeyActivate($event)"
  >
  <div class="flex gap-2 items-center px-2 py-4 min-w-0 w-full">
    <img [src]="line.agencyId | agencyLogo" [attr.alt]="line.agencyName" class="h-6 shrink-0 cursor-pointer" (click)="openContactInfoModal(); $event.stopPropagation()"/>
    <span class="bg-gray px-1 py-0.5 rounded-lg text-xs shrink-0">{{line.routeName}}</span>
    <h3 class="text-base font-normal m-0 min-w-0">{{toDirectionText}} {{tripHeadsign}}, {{destinationCityText}}</h3>
  </div>
  <hr class="border-gray-500 border-t-1 w-full opacity-50 m-0" />
  <div class="flex justify-between items-center w-full min-w-0 gap-2">
    <div class="flex flex-col p-2 min-w-0 flex-1">
      <span class="text-xs text-[#5C748F] font-normal">{{firstStationText}}</span>
      <span class="text-base font-normal">{{originStopName}} <span>{{line.originStopCode}}</span> @if (line.originPlatformNumber) {
      <span class="text-base">, {{platformText}} {{line.originPlatformNumber}}</span>
    } - {{originCityText}}</span>
  </div>
  <div class="p-2 shrink-0 tabular-nums">
    <span class="text-sm">{{line.originDepartureTime | hour}}</span>
  </div>
</div>
<div class="flex justify-between items-center w-full min-w-0 gap-2">
  <div class="flex flex-col p-2 min-w-0 flex-1">
    <span class="text-xs text-[#5C748F] font-normal">{{lastStationText}}</span>
    <span class="text-base font-normal">{{destinationStopName}} <span>{{line.destinationStopCode}}</span> @if (line.destinationPlatformNumber) {
    <span class="text-base">, {{platformText}} {{line.destinationPlatformNumber}}</span>
  } - {{destinationCityText}}</span>
</div>
<div class="p-2 shrink-0 tabular-nums">
  <span class="text-sm">{{line.destinationArrivalTime | hour}}</span>
</div>
</div>
@if (hasSpecialData) {
  <app-result-list-item-special-data class="w-full" [specialData]="line.specialData" [specialMessages]="line.specialMessages" [agencyId]="line.agencyId" (click)="$event.stopPropagation()" />
}
</div>
